function addId(target, value) {
  if (value === undefined || value === null || value === '') return
  target.add(String(value))
}

function getLeaveId(leave = {}) {
  return leave.id ?? leave.leaveId ?? leave._raw?.leave_id ?? leave._raw?.id ?? null
}

function getInstanceId(leave = {}) {
  return leave.instanceId ?? leave._raw?.instance_id ?? leave._raw?.instanceId ?? null
}

function hasPendingApprovalKey(map, value, prefix = '') {
  if (!map || value === undefined || value === null || value === '') return false
  const key = prefix ? `${prefix}:${value}` : String(value)
  return !!map[key]
}

export function getCurrentApprovalActorIds(state = {}) {
  const ids = new Set()
  const userInfo = state.userInfo || {}
  const currentUser = state.currentUser || {}

  addId(ids, userInfo.user_id)
  addId(ids, userInfo.id)
  addId(ids, userInfo.teacher_id)
  addId(ids, userInfo.teacherId)
  addId(ids, userInfo.subadmin_id)
  addId(ids, userInfo.subadminId)
  addId(ids, userInfo?.subadmin?.subadmin_id)
  addId(ids, userInfo?.subadmin?.subadminId)
  addId(ids, currentUser.id)
  addId(ids, currentUser.user_id)
  addId(ids, currentUser.userId)
  addId(ids, currentUser.subadmin_id)
  addId(ids, currentUser.subadminId)

  return ids
}

export function buildPendingApprovalKeyMap(records = []) {
  return records.reduce((map, record) => {
    const leaveId = record?.leave_id ?? record?.leaveId ?? record?.id
    const instanceId = record?.instance_id ?? record?.instanceId
    if (leaveId !== undefined && leaveId !== null && leaveId !== '') {
      map[String(leaveId)] = true
    }
    if (instanceId !== undefined && instanceId !== null && instanceId !== '') {
      map[`instance:${instanceId}`] = true
    }
    return map
  }, {})
}

export function canCurrentUserApproveLeave(leave, state = {}, pendingApprovalKeyMap = null) {
  if (!leave || leave.status !== '待审批') return false
  if (leave.approvalStatus != null && leave.approvalStatus !== 'pending') return false

  const hasPendingMap = !!(pendingApprovalKeyMap && Object.keys(pendingApprovalKeyMap).length)
  const leaveId = getLeaveId(leave)
  const instanceId = getInstanceId(leave)
  if (hasPendingMap) {
    return hasPendingApprovalKey(pendingApprovalKeyMap, leaveId) || hasPendingApprovalKey(pendingApprovalKeyMap, instanceId, 'instance')
  }

  const currentApproverId = leave.currentApproverId
    ?? leave.instanceDetail?.instance?.current_approver_id
    ?? leave._raw?.current_approver_id
    ?? leave._raw?.currentApproverId

  if (currentApproverId === undefined || currentApproverId === null || currentApproverId === '') {
    return true
  }

  return getCurrentApprovalActorIds(state).has(String(currentApproverId))
}

export function resolveLeaveInstanceId(leave) {
  return getInstanceId(leave)
}

export function resolveLeaveId(leave) {
  return getLeaveId(leave)
}

export function removePendingApprovalKeys(map, leave) {
  if (!map) return map
  const next = { ...map }
  const leaveId = getLeaveId(leave)
  const instanceId = getInstanceId(leave)
  if (leaveId !== undefined && leaveId !== null && leaveId !== '') {
    delete next[String(leaveId)]
  }
  if (instanceId !== undefined && instanceId !== null && instanceId !== '') {
    delete next[`instance:${instanceId}`]
  }
  return next
}
